/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import { array, object, bool, string } from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../atoms/CollectionTitle";
import { DfpComponent } from "../../ads/dfp-component";
import { OtherStory } from "./OtherStory";
import { RowSeparator } from "../../atoms/RowSeparator";

import "./three-col-twelve-stories.m.css";

const Column = ({
  collection,
  showColumnSeparator,
  showStorySeparator,
  showTimestamp,
  showReadTime,
  showColumnTitle,
  sectionSlug,
}) => {
  const stories = get(collection, ["items"], []).filter((item) => item.type === "story");

  return (
    <div styleName="column" style={{ border: showColumnSeparator || "none" }}>
      {showColumnTitle && (
        <CollectionTitle collection={collection} styleName="three-col-twelve-stories" sectionSlug={sectionSlug} />
      )}
      {stories.slice(0, 4).map((item) => (
        <OtherStory
          story={item.story}
          key={item.id}
          showStorySeparator={showStorySeparator}
          showTimestamp={showTimestamp}
          showReadTime={showReadTime}
          sectionSlug={sectionSlug}
        />
      ))}
    </div>
  );
};

Column.propTypes = {
  collection: object,
  showStorySeparator: bool,
  showColumnSeparator: bool,
  showTimestamp: bool,
  showReadTime: bool,
  showColumnTitle: bool,
  sectionSlug: string,
};

export function ThreeColTwelveStories({ collection, stories, extraProp = "" }) {
  const {
    show_timestamp,
    show_read_time,
    show_column_title,
    show_column_separator,
    show_row_separator,
    show_story_separator,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});

  const filteredCollection = get(collection, ["items"], [])
    .slice(0, 3)
    .map((collections) => {
      return collections.type === "collection" ? collections : [];
    });
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  return (
    <div className="row-component">
      <div styleName={`three-col-twelve-stories`}>
        <div styleName="columns">
          {filteredCollection.slice(0, 3).map((item) => (
            <Column
              key={item.id}
              collection={item}
              showTimestamp={show_timestamp}
              showReadTime={show_read_time}
              showColumnTitle={show_column_title}
              showStorySeparator={show_story_separator}
              showColumnSeparator={show_column_separator}
              sectionSlug={sectionSlug}
            />
          ))}
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`${pageType}-${collection.slug}-row-bottom-ad`}
          path={show_row_ad_unit_bottom}
          size={bottomAdConfig.sizes}
          viewPortSizeMapping={bottomAdConfig.view_port_size_mapping}
        />
      )}
    </div>
  );
}

ThreeColTwelveStories.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

ThreeColTwelveStories.storyLimit = 12;
